import { createClient } from '@supabase/supabase-js'
import type { Database, TypedSupabaseClient } from '../types/supabase.js'

// Strict environment variable validation
const supabaseUrl: string = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey: string = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing required Supabase environment variables')
}

// Type-safe Supabase client with database schema
export const supabase: TypedSupabaseClient = createClient<Database>(supabaseUrl, supabaseAnonKey)

// Environment validation for development
if (import.meta.env.DEV) {
  console.log('Supabase client initialized with strict typing')
}
